<template>
  <div>
    <b-modal v-model="isShow" id="modal-1"  @ok="save" title="Nhập lý do bỏ duyệt dịch vụ">
      <el-form
        :model="mData.dataForm"
        :rules="mData.validForm"
        ref="myForm"
        label-width="100%"
        label-position="top"
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Lý do" prop="ly_do_tu_choi">
              <el-input
                type="textarea"
                :rows="2"
                v-model="mData.dataForm.ly_do_tu_choi"
                clearable
              ></el-input>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </b-modal>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import TourDuLichModel from '@/views/admin/TourDuLich/TourDuLichModel';
import TourDuLichChoDuyetApi from '@/moduleApi/TourDuLichChoDuyetApi';

export default {
  props: ["isShow", "dataObject"],
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "TourDuLich",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataDefault: {
          listProvince: [],
        },
        dataForm: MethodService.copyObject(TourDuLichModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          TourDuLichModel.dataFormOther.fileUploadOption
        ),
        validForm: TourDuLichModel.validForm,
      },
    };
  },
  methods: {
    async save() {
      let data = this.dataObject;
      data.ly_do_tu_choi = this.mData.dataForm.ly_do_tu_choi;
      data.duyet={
        duoc_duyet :false
      }
      await TourDuLichChoDuyetApi.approvedDichVuTour(data);
      this.fn_go();
      this.$store.commit("fn_countTourDuLich");
    },
    fn_go() {
      this.$router.go(-1);
    },

  },
};
</script>
